import { SettingsValueProps } from './components/settings/type';
// routes
// import { PATH_PAGE } from './routes/paths';

// App configuration
const defaultCallbackPath = '/auth/bpd/callback';

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/BigPurpleDot/',
  instagram: 'https://www.instagram.com/bigpurpledot/',
  linkedin: 'https://www.linkedin.com/company/big-purple-dot',
  twitter: 'https://twitter.com/big_purple_dot?lang=bg',
};
export const SUPPORT_EMAIL = 'support@bigpurpledot.com';
export const ABBREVIATIONS = {
  va: 'Veterans Administration',
  fha: 'Federal Housing Administration',
  cnv: 'Conventional',
  pp: 'Private Party',
  sba: 'Small Business Administration',
  rev: 'Reverse Mortgage',
  ss: 'Seller side',
  bs: 'Buyer side',
  ds: 'Dual side',
};
export const SIGNUP_PATH = process.env.NEXT_PUBLIC_SIGNUP_PATH || '';
export const API_PATH = process.env.NEXT_PUBLIC_API_PATH || '';
export const API_ORIGIN = process.env.NEXT_PUBLIC_API_ORIGIN || '';
export const OAUTH_DISABLED = process.env.NEXT_PUBLIC_OAUTH_DISABLED === 'true' ? true : false;
// export const OAUTH_DISABLED = true;
export const DOOR_KEEPER_API = {
  apiOrigin: API_ORIGIN || '',
  authUrl: process.env.NEXT_PUBLIC_OAUTH_AUTH_URL || '',
  clientId: process.env.NEXT_PUBLIC_OAUTH_CLIENT_ID || '',
  redirectPath: process.env.NEXT_PUBLIC_OAUTH_REDIRECT_PATH || defaultCallbackPath,
};
export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_MAPS_API_KEY || '';

// ROOT PATH AFTER LOGIN SUCCESSFUL
// export const PATH_AFTER_LOGIN = PATH_PAGE.loanOfficers.dashboard;
// export const DEFAULT_PATH_AFTER_LOGIN = '/';
export const DEFAULT_PATH_AFTER_LOGIN = '/loan-officers/dashboard';

// ALLOWED PATHS WITHOUT OAUTH
export const ALLOWED_PATHS = ['/', '/404', '/500', '/login', '/login-error'];
// PATHS WHERE WE BLOCK BODY SCROLL(SEARCH FORMS MOSTLY)
export const NO_SCROLL_PATHS = [
  '/agents/teams/search',
  '/agents/search',
  '/loan-officers/search',
  '/loan-officers/company-trends/search',
  '/opportunities/search',
];
export const CRM_REDIRECT_LINK = 'https://bigpurpledot.com/company_redirect';

// LAYOUT
export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
  DASHBOARD_MOBILE_OFFSET_HEIGHT: 64 - 16,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 256,
  DASHBOARD_NARROW_WIDTH: 220,
  DASHBOARD_COLLAPSE_WIDTH: 96,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
export const cookiesExpires = 3;

export const cookiesKey = {
  themeMode: 'themeMode',
  themeDirection: 'themeDirection',
  themeColorPresets: 'themeColorPresets',
  themeLayout: 'themeLayout',
  themeStretch: 'themeStretch',
};

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};

// export const DEFAULT_PERIOD = '14';
export const DEFAULT_PERIOD: Period = 14;
export const FIRST_PAGE = 1;
export const LOCAL_STORAGE_PARAMS_VERSION = '1.0.0';

export const FILTER_OPTIONS_PERIOD = [
  {
    value: '3',
    label: '3 Months',
  },
  {
    value: '6',
    label: '6 Months',
  },
  {
    value: '9',
    label: '9 Months',
  },
  {
    value: '12',
    label: '12 Months',
  },
  {
    value: '14',
    label: '14 Months',
  },
];
